jQuery(function($) {
	if (!$('.school_of_surf_grid .slider .slides').length)
		return;

	var popup = $('.school_of_surf_grid .popup_trigger');
	var close = $('.close');

	$('.school_of_surf_grid .slider .slides').each(function(){

		initializeSlick(this, {
			accessibility: true,
			infinite: true,
			speed: 1500,
			slidesToShow: 1,
			arrows: false,
			autoplay: true,
			fade: true,
			pauseOnHover: false,
			nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
			prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
		});

	});

	initializeSlick('.school_of_surf_grid_holder .slider_holder .slides_holder', {
		accessibility: true,
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		nextArrow: '<button class="slider_arrow next_arrow" tabindex="0">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow" tabindex="0">Previous</button>',
		responsive: [
			{
				breakpoint: 1149,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1
				}
			},
		]
	});

	popup.modaal({
		hide_close: true,
		background: '#FFFFFF',
		overlay_opacity: .9,
		// after_close: function(){ document.location.href = "#"; }
	});


	close.click(function() {
		popup.modaal('close');
	});
});

